import { z } from 'zod';
import { dateSchema, objectIdSchema } from '../validation';

/**
 * Audit trail captured when a super-admin blocks a {@link User} or
 * {@link Org}. Admin-only — never returned on network-party reads
 * (`auth/me`, `can-use-app`, carrier/customer SDKs).
 */
export const blockMetaSchema = z.object({
  /** Short reason — preset label or free text entered by the admin. */
  reason: z.string().trim().min(1).max(200),
  /** Optional longer context for Hero staff (support / compliance). */
  internalNote: z.string().trim().max(2000).optional(),
  blockedAt: dateSchema,
  /** Super-admin `User._id` who performed the block. */
  blockedByUserId: objectIdSchema.optional(),
});

export type BlockMeta = z.infer<typeof blockMetaSchema>;

/** Request body fragment — server stamps `blockedAt` / `blockedByUserId`. */
export const blockMetaInputSchema = blockMetaSchema.pick({
  reason: true,
  internalNote: true,
});

export type BlockMetaInput = z.infer<typeof blockMetaInputSchema>;

/** Preset reasons shown in the admin block dialog. */
export const BLOCK_REASON_PRESETS = [
  'fraud',
  'compliance',
  'abuse',
  'payment',
  'other',
] as const;

export type BlockReasonPreset = (typeof BLOCK_REASON_PRESETS)[number];
